export enum SmsTemplateNames {
  smsLrpQuote = 'smsLrpQuote',
  smsCustom = 'smsCustom',
  smsSubscribe = 'smsSubscribe',
  smsUnsubscribe = 'smsUnsubscribe',
  smsOptInConfirmation = 'smsOptInConfirmation',
}
